module.exports = __webpack_public_path__ + "12af83b61e3f9a9e3821c99af6c5c03b.png";